import { NavLink } from "react-router-dom";

const Menu = () => {
    return (
        <>
            <div className="collapse navbar-collapse header_menu" id="navbarSupportedContent">
                <ul className="navbar-nav ms-auto mb-2 mb-lg-0 ">
                    <li className="nav-item">
                        <NavLink className="nav-link px-4" to={'/'} >Home</NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink className="nav-link px-4" to={'/about'}>About</NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink className="nav-link px-4" to={'/offerings'}>Offerings</NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink className="nav-link px-4" to={'/domain'}>Domains</NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink className="nav-link px-4" to={'/contact'}>Contact</NavLink>
                    </li>
                </ul>
            </div>
        </>
    )
}
export default Menu;